import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { CostCenterDto } from '../models/CostCenterDto';
import { CostCenterRequest } from '../models/requests/new-costcenter-request';
@Injectable({
  providedIn: 'root'
})
export class CostCentersService {


  constructor(private httpClient: HttpClient) { }
  getCostCenters(): Observable<ApiResponseObject<CostCenterDto[]>> {
    return this.httpClient.get<ApiResponseObject<CostCenterDto[]>>(`${environment.apiUrl}/CostCenters`);
  }
  
  saveCostCenter(newCostCenterRequest: CostCenterRequest): Observable<ApiResponseObject<CostCenterDto>> {
   
    return this.httpClient.post<ApiResponseObject<CostCenterDto>>(`${environment.apiUrl}/CostCenters`, newCostCenterRequest);
  }
}
